// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileComplianceBlock-modulecontent__h18UI";
var _2 = "ApplicantProfileComplianceBlock-modulefacts__BZPKL";
var _3 = "ApplicantProfileComplianceBlock-moduleline__X3uuW";
var _4 = "ApplicantProfileComplianceBlock-modulelines__atURL";
export { _1 as "content", _2 as "facts", _3 as "line", _4 as "lines" }
